import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Flex, Divider, Text } from 'components/ui';
import { CATEGORIES } from 'ai/constants/categories';
import LanguageLocale from 'utils/LanguageLocale';

const getContextualDividerLabel = (label, categoryId) => {
    const getText = LanguageLocale.getLocaleResourceFile('ai/components/SuperChat/ContextualDivider/locales', 'ContextualDivider');

    if (categoryId === CATEGORIES.GIFT) {
        return (
            <Text
                fontSize='xs'
                css={styles.label}
            >
                {getText('giftFinder')}
            </Text>
        );
    }

    return (
        <Text
            fontSize='xs'
            css={styles.label}
        >
            {label}
        </Text>
    );
};

function ContextualDivider({ label, categoryId }) {
    if (!label && categoryId !== CATEGORIES.GIFT) {
        return null;
    }

    return (
        <Flex
            flexDirection='column'
            width='100%'
        >
            <Divider marginBottom={2} />
            {getContextualDividerLabel(label, categoryId)}
        </Flex>
    );
}

const styles = {
    label: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
};

export default wrapFunctionalComponent(ContextualDivider, 'ContextualDivider');
